// Shared by browser apps and the API. Only a published, effective release can
// require acceptance or change access; draft pages never activate policy rules.
const registry = require('./policies.json');
const POLICY_IDS = ['terms', 'privacy', 'refunds'];

function getPublishedPolicySet(version, now = Date.now(), source = registry) {
  if (!version || !Object.prototype.hasOwnProperty.call(source.versions, version)) return null;
  const release = source.versions[version];
  const effectiveAtMs = Date.parse(`${release.effectiveDate}T00:00:00+08:00`);
  if (release.status !== 'published' || !Number.isFinite(effectiveAtMs) || effectiveAtMs > now) return null;
  return {
    version,
    effectiveDate: release.effectiveDate,
    effectiveAtMs,
    versions: Object.fromEntries(POLICY_IDS.map((id) => [id, version])),
    guestNoticeVersion: version,
  };
}

function getActivePolicySet(now = Date.now(), source = registry) {
  if (!source.currentVersion) return null;
  const current = getPublishedPolicySet(source.currentVersion, now, source);
  if (current) return current;
  // A scheduled release must not suspend an already effective policy.
  return Object.keys(source.versions)
    .map((version) => getPublishedPolicySet(version, now, source))
    .filter(Boolean)
    .sort((left, right) => right.effectiveAtMs - left.effectiveAtMs)[0] || null;
}

function isPolicyAcceptanceValid(acceptance, active = getActivePolicySet()) {
  return Boolean(active && acceptance && acceptance.accepted === true
    && acceptance.versions && typeof acceptance.versions === 'object'
    && POLICY_IDS.every((id) => Object.prototype.hasOwnProperty.call(acceptance.versions, id)
      && acceptance.versions[id] === active.versions[id]));
}

module.exports = { getActivePolicySet, getPublishedPolicySet, isPolicyAcceptanceValid };
